// extracted by mini-css-extract-plugin
export default {"milestoneLink":"MilestoneMetadata-module__milestoneLink--SF0lK","milestoneTitle":"MilestoneMetadata-module__milestoneTitle--hLT9z"};